export default __webpack_public_path__ + "static/nikdave-c03a0ad2f01cb6e82a627a79579f74a8.png";